<div class="wrapper" [class.is-mobile-open]="mobileMenuOpen">
    <!-- Botón hamburguesa: solo visible en mobile (<992px) para abrir/cerrar el sidebar -->
    <button type="button"
            class="mobile-menu-toggle"
            (click)="toggleMobileMenu()"
            [attr.aria-label]="mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'">
        <i class="material-icons">{{ mobileMenuOpen ? 'close' : 'menu' }}</i>
    </button>

    <!-- Backdrop: cierra el sidebar al tocar fuera (solo mobile) -->
    <div class="mobile-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>

    <!-- Sidebar: drawer off-canvas en mobile, fijo en desktop -->
    <div class="sidebar" data-color="white" data-background-color="white">
        <app-sidebar-new></app-sidebar-new>
    </div>

    <!-- Main Panel: full width en mobile, width calculado en desktop -->
    <div class="main-panel">
        <!-- Navbar eliminado: el nuevo sidebar (app-sidebar-new) ya provee cerrar sesión y el toggle de minimizar. -->
        <!-- <app-navbar-cmp></app-navbar-cmp> -->
        <router-outlet></router-outlet>
        <!-- Toasts globales -->
        <app-toast></app-toast>
        <div *ngIf="!isMap()">
            <app-footer-cmp></app-footer-cmp>
        </div>
    </div>
</div>
